import React from 'react';
import PropTypes from 'prop-types';

import QuestionText from '../QuestionText';
import { questionType } from '../../constants/types';
import TextInput from '../TextInput';
import { withLang, langType } from '../../i18n';
import styles from './freeQuestion.module.css';
import sharedStyles from '../../styles/shared';

const FreeQuestion = ({
  orderNum, question, onChange, errorState, lang, answer, selectedLang, translate
}) => {
  function handleChange(event) {
    onChange(event.target.name, event.target.value.length > 0 ? event.target.value : null);
  }
  const questionElementId = `question_${question.id}`;
  const errorId = `err_${question.id}`;

  return (
    <div
      className={`${sharedStyles.row} ${sharedStyles.questionRow}`}
      aria-labelledby={questionElementId}
      aria-required={question.required || undefined}
      aria-invalid={errorState && question.required ? 'true' : undefined}
      aria-describedby={errorState ? errorId : undefined}
    >
      <QuestionText
        id={questionElementId}
        errorId={errorId}
        showError={errorState && question.required}
        question={question}
        orderNum={orderNum}
        lang={selectedLang || lang}
        translate={translate}
      />
      <div className={styles.col}>
        <TextInput
          className={styles.textarea}
          name={question.id}
          onChange={handleChange}
          value={answer || ''}
          maxLength={800}
          textarea
        />
      </div>
    </div>

  );
};

FreeQuestion.defaultProps = {
  answer: ''
};

const {
  number, func, bool, string
} = PropTypes;

FreeQuestion.propTypes = {
  orderNum: number.isRequired,
  question: questionType.isRequired,
  onChange: func.isRequired,
  errorState: bool,
  answer: string,
  selectedLang: string,
  ...langType
};

FreeQuestion.defaultProps = {
  errorState: false,
  selectedLang: null
};

export default withLang(FreeQuestion);
